// Soundwave uploads: the Upload Lift app's "Soundwave" field is configured
// (in the app's admin) to accept audio files only, and validates it. Customers
// should be able to send either an audio file OR an image of the soundwave, so
// widen the accepted types (and the button text) for the soundwave fields in
// the app config the storefront loads, before the widget builds itself. This
// only affects this theme; the app's saved settings are untouched.
(function () {
  var TYPES = ['audio/*', 'image/*'];
  var TEXT = 'Select audio file or soundwave image';

  function patch(cfg) {
    if (!cfg || !cfg.fields) return;
    cfg.fields.forEach(function (f) {
      if (/^#uploadlift-soundwave(-back)?$/.test(f.selector || '')) {
        f.fileMimeTypes = TYPES;
        f.text = TEXT;
        // no crop/edit step for a soundwave screenshot (audio has none either)
        f.imageEditor = false;
        f.imageEditorOpen = false;
      }
    });
    // Drop upload fields the app has no CSS selector configured for. With no
    // container to attach to, Cloudlift falls back to appending itself
    // directly onto the product form instead of skipping the field - a
    // second, unlabelled-looking "Upload Image" box duplicating whichever
    // real field (Fingerprint, Handwriting, ...) the product actually uses.
    // Confirmed on the Paw/Nose Print Signet Ring: the app's own
    // "Paw/Nose Print" field has selector: "" and auto-appends below the
    // real #uploadlift-fingerprint widget the theme already renders for that
    // same upload. Every field the theme actually uses (#uploadlift-*) has a
    // real selector, so stripping selector-less fields only removes stray
    // app-side entries like this one - never a field the theme relies on.
    cfg.fields = cfg.fields.filter(function (f) {
      return (f.selector || '').trim() !== '';
    });
  }

  var C = (window.Cloudlift = window.Cloudlift || {});
  if (C.upload && C.upload.config) {
    patch(C.upload.config);
    return;
  }
  // Config script has not run yet: patch the moment it assigns Cloudlift.upload.
  try {
    Object.defineProperty(C, 'upload', {
      configurable: true,
      enumerable: true,
      get: function () { return undefined; },
      set: function (value) {
        if (value && value.config) patch(value.config);
        Object.defineProperty(C, 'upload', { value: value, writable: true, configurable: true, enumerable: true });
      }
    });
  } catch (e) {}
})();

// Keeps the sticky header directly below the Qikify announcement bar.
// The bar is position:fixed, but Canopy's sticky header sits at top:-1px, so
// once scrolled the bar covers the top of the header. Measure the bar and
// publish its height as --sticky-bar-offset (used by anthology-typography.css).
// The bar's rotating messages briefly report 0 height while it animates in,
// so a zero/oversized reading is ignored and the last good height is kept -
// but the reserved space always tracks the CURRENT reading, not a running
// maximum. The bar rotates through several announcements (some one line,
// some two), and the previous version latched onto the tallest one it had
// ever seen and never gave the space back - a shorter announcement then left
// a visible gap between the bar and the header below it on mobile. Polling
// also used to stop after 15s, which was fine while every message was the
// same height but missed a later rotation to a different height entirely.
(function () {
  var root = document.documentElement;
  var MAX = 120;
  var best = 0;

  function measure() {
    var bars = document.querySelectorAll('.smartbar-bar--top_push_sticky, .smartbar-bar--top_sticky');
    var h = 0;
    bars.forEach(function (bar) {
      h = Math.max(h, bar.getBoundingClientRect().height);
    });
    if (h > 0 && h <= MAX) best = h;
    root.style.setProperty('--sticky-bar-offset', Math.round(best) + 'px');
  }

  function init() {
    measure();
    window.addEventListener('resize', function () {
      best = 0;
      measure();
    });
    window.addEventListener('load', measure);
    // Keep polling for the life of the page, not just the first 15s: the
    // bar's rotating messages can change height at any point, and this is a
    // single cheap getBoundingClientRect() read.
    setInterval(measure, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Candy Rack "Need anything else?" upsell pop-up (shown after Add to bag).
// Candy Rack holds the add-to-cart until the shopper clicks CONTINUE, and
// CONTINUE then only closes the pop-up. Send shoppers to the cart afterwards -
// but only once the item has actually landed in the cart (redirecting straight
// away could cancel the pending add). The pop-up lives in a same-origin srcdoc
// iframe that is re-rendered each time it opens, so bind by polling and flag
// each document.
(function () {
  var CART_URL = '/cart';
  var redirecting = false;

  function snapshot() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return cart.items.map(function (i) { return i.key + ':' + i.quantity; }).join('|');
      })
      .catch(function () { return 'error'; });
  }

  function goToCartWhenAdded(baseline) {
    if (redirecting) return;
    redirecting = true;
    var start = Date.now();
    (function poll() {
      snapshot().then(function (now) {
        var added = baseline !== null && now !== baseline;
        if (added || Date.now() - start > 7000) {
          setTimeout(function () { window.location.href = CART_URL; }, 300);
        } else {
          setTimeout(poll, 300);
        }
      });
    })();
  }

  function bind() {
    var frame = document.getElementById('candyrack-frame');
    if (!frame) return;
    var doc;
    try { doc = frame.contentDocument; } catch (e) { return; }
    if (!doc || !doc.documentElement || doc.documentElement.dataset.anthologyContinue) return;
    doc.documentElement.dataset.anthologyContinue = 'true';
    var baseline = null;
    snapshot().then(function (s) { baseline = s; });
    doc.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('button');
      if (btn && /^\s*continue\s*$/i.test(btn.textContent)) {
        goToCartWhenAdded(baseline);
      }
    }, true);
  }

  setInterval(bind, 400);
})();

// "Buy Now, Customize Later" (checkbox on the product page, stored in
// localStorage). Matches the old theme's cart template: when the cart page
// loads with the flag set, record it as a cart attribute so it reaches the
// order, then clear the flag.
(function () {
  if (!/^\/cart\/?$/.test(window.location.pathname)) return;
  try {
    if (localStorage.getItem('anthology_customize_later') === 'true') {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Customization Method': 'Send it in later' } })
      }).then(function () {
        localStorage.removeItem('anthology_customize_later');
      });
    }
  } catch (e) {}
})();

// Review stars + count at the top of a product listing: clicking them scrolls
// down to the reviews widget (Ali Reviews) on the PageFly page below. The
// rating block is re-rendered on variant change, so use event delegation.
(function () {
  var RATING = '.product-info__rating';
  var TARGET = '.alireviews-review-box';

  var style = document.createElement('style');
  style.textContent =
    RATING + '{cursor:pointer}' +
    RATING + ':hover .rating__count{text-decoration:underline}';
  document.head.appendChild(style);

  function headerOffset() {
    var sticky = document.querySelector('.cc-header--sticky');
    var bar = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sticky-bar-offset'), 10) || 0;
    return (sticky ? sticky.getBoundingClientRect().height : 0) + bar + 16;
  }

  function targetTop() {
    var t = document.querySelector(TARGET);
    if (!t) return null;
    // The widget renders lazily and can be 0px tall; fall back to its
    // nearest visible PageFly wrapper so we still land on the right spot.
    var el = t;
    while (el && el !== document.body && el.getBoundingClientRect().height < 1) {
      el = el.parentElement;
    }
    if (!el || el === document.body) el = t;
    return el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
  }

  function scrollToReviews() {
    var top = targetTop();
    if (top === null) return false;
    window.scrollTo({ top: top, behavior: 'smooth' });
    // Lazy content above/around the widget can shift the layout while we
    // scroll; re-align once it settles.
    [900, 2200].forEach(function (delay) {
      setTimeout(function () {
        var again = targetTop();
        if (again !== null && Math.abs(again - window.pageYOffset) > 40) {
          window.scrollTo({ top: again, behavior: 'smooth' });
        }
      }, delay);
    });
    return true;
  }

  function activate(e) {
    var rating = e.target.closest && e.target.closest(RATING);
    if (!rating) return;
    if (scrollToReviews()) e.preventDefault();
  }

  document.addEventListener('click', activate);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    if (e.target.matches && e.target.matches(RATING)) activate(e);
  });

  // Make the (re-rendered) rating block reachable by keyboard / screen readers.
  function decorate() {
    document.querySelectorAll(RATING).forEach(function (el) {
      if (el.getAttribute('role')) return;
      el.setAttribute('role', 'link');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', 'Read customer reviews');
    });
  }
  decorate();
  new MutationObserver(decorate).observe(document.body, { childList: true, subtree: true });
})();

// PageFly product cards (home page best sellers, related carousels):
//  - clicking the product IMAGE now opens the product, like the title does
//    (PageFly only wires the title, via its data-href);
//  - the "More Options" button is an <a> with no link and no handler, so it
//    does nothing - hide it.
// PageFly renders these client-side and can re-render them, so this uses
// event delegation plus a small observer rather than editing its output.
(function () {
  var CARD = '.pf-product-form';
  var MEDIA = '[data-pf-type="ProductMedia2"]';

  var style = document.createElement('style');
  style.textContent = CARD + ' ' + MEDIA + '{cursor:pointer}';
  document.head.appendChild(style);

  function productUrl(card) {
    var title = card.querySelector('[data-pf-type="ProductTitle"][data-href]');
    if (title) return title.getAttribute('data-href');
    var id = card.getAttribute('data-productid');
    var p = window.__pageflyProducts && window.__pageflyProducts[id];
    if (p && p.url) return p.url;
    if (p && p.handle) return '/products/' + p.handle;
    return null;
  }

  var down = null;
  document.addEventListener('pointerdown', function (e) {
    down = { x: e.clientX, y: e.clientY };
  }, true);

  document.addEventListener('click', function (e) {
    var media = e.target.closest && e.target.closest(CARD + ' ' + MEDIA);
    if (!media) return;
    // slider arrows / dots / any real control keep their own behaviour
    if (e.target.closest('button, a, input, select, [class*="pf-slider-"], [class*="pf-dot"]')) return;
    // a drag / swipe is not a click
    if (down && (Math.abs(e.clientX - down.x) > 8 || Math.abs(e.clientY - down.y) > 8)) return;
    var url = productUrl(media.closest(CARD));
    if (!url) return;
    e.preventDefault();
    if (e.metaKey || e.ctrlKey) window.open(url, '_blank');
    else window.location.href = url;
  });

  function hideMoreOptions() {
    document.querySelectorAll(CARD + ' a[data-pf-type="Button2"]').forEach(function (a) {
      if (a.dataset.anthologyHidden || a.textContent.trim().toLowerCase() !== 'more options') return;
      a.dataset.anthologyHidden = 'true';
      a.style.display = 'none';
      // drop the now-empty wrapper too so no gap is left behind
      var wrap = a.parentElement;
      if (wrap && wrap !== a.closest(CARD) && wrap.children.length === 1) wrap.style.display = 'none';
    });
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      hideMoreOptions();
    });
  }
  hideMoreOptions();
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
})();
